import * as actionTypes from './actionTypes'

const initialState = {
    orderData: [],
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.UPDATE_ORDERS:
            state = {
                ...state,
                orderData: action.payload.data,
            }
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default reducer;
